import { createSlice } from '@reduxjs/toolkit';
import ApiServices from 'api/apexchat.api.services';
import { HostAPI } from 'api/endpoints';

/**
 * @name @createSlice
 * @description create redux store slice for auth
 **/
export const hostSlice = createSlice({
  name: 'hosts',
  initialState: {
    hosts: []
  },

  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/

    setHostsToState: (state, action) => {
      state.hosts = action.payload;
    }
  }
});
export const { setHostsToState } = hostSlice.actions;

/**
 * These function called thunk and allows to perform async logic
 * It can be dispatched like a regular action: `dispatch(data)`
 **/

/* called a selector and allows to select values from the state */

export const selectHosts = state => {
  return state.hosts;
};

export const getHosts = payload => {
  let hostAPI = HostAPI.getOwnedHosts;
  return ApiServices.get(hostAPI);
};

export const getHostById = hostId => {
  let hostAPI = HostAPI.getHost(hostId);
  return ApiServices.get(hostAPI);
};

export default hostSlice.reducer;
